var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIgnoreInactive = function SvgIgnoreInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ignoreInactive_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#C7C7CC",
    rx: 10.435
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m36.61 32.306-3.62-2.868c0-.082.04-.123.04-.205 0-.287-.12-.615-.361-.86-.764-.86-2.253-2.13-2.253-6.35 0-3.156-2.171-5.696-5.148-6.351v-.86c0-.697-.563-1.312-1.247-1.312-.724 0-1.287.615-1.287 1.311v.86c-1.649.37-3.016 1.27-3.941 2.582l-5.832-4.59c-.281-.245-.684-.163-.885.124l-.804 1.024a.62.62 0 0 0 .12.902l23.65 18.641c.281.246.683.164.885-.123l.804-1.024a.62.62 0 0 0-.12-.901m-19.144-8.481c-.362 2.786-1.489 3.81-2.132 4.548-.241.245-.362.573-.322.86 0 .697.483 1.311 1.287 1.311h9.734zm6.555 10.652c1.408 0 2.534-1.147 2.534-2.622h-5.108c0 1.475 1.127 2.622 2.575 2.622"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ignoreInactive_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 10.435
  })))));
};
export default SvgIgnoreInactive;